<div class="loader" [hidden]="status != LOADING">
    <div class="dimmed">
        <div class="dimmed_title"></div>
    </div>
</div>
<div *ngIf="status == DONE" class="version-origin-artwork">
    <ng-container *ngIf="group">
        <header class="counter-header" >
            <h5>
                <em>ORIGINAL ARTWORK</em>
            </h5>
        </header>
        <div class="group-item">
            <header (click)="openVersions()">
                <strong class="group-counter">{{group.total}}</strong>
                <core-labels-list [labels]="group.labels"></core-labels-list>
                <span class="arrow-marker" [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
            </header>
            <div [hidden]="!opened">
                <ul class="version-related-item">
                    <li>
                        <core-version-files-list-checkbox
                          [version]="artwork"
                          [feedbacks]="feedbacks"
                          [selected]="selected"
                          (selectedChange)="onChange($event);"
                          [disabled]="disabled"
                        ></core-version-files-list-checkbox>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>
</div>
<div *ngIf="status == ERROR" class="v-origin-artwork-error">
    <core-helpers-box-alert-message-icon
        [text]="'There was an error loading the orginal artwork. Please refresh your screen.<br/>If the error persists, please reach out to our support team through the Help Me button.'"
        [icon]="'alert'"
    ></core-helpers-box-alert-message-icon>
</div>

